module.exports = __webpack_public_path__ + "img/db103f3.png";